module.exports = __webpack_public_path__ + "images/mdj/members/resume/resume_end_screen/icon-man-dd4be45dfa0195be7722a849e6bce6b4.png";